/**
 * The provider window. It is opened blank, synchronously inside the trusted
 * click (anything later is a popup the browser blocks), and only pointed at
 * the provider once /pay has answered.
 *
 * `popup.opener` is deliberately left alone: setting it to null makes a later
 * `popup.close()` a no-op in Chromium. Provider pages are trusted partners or
 * our own script-free mock page, and real providers sever the opener with COOP.
 */

export const POPUP_FEATURES = 'popup,width=480,height=760';

export function openBlankPopup(name: string): Window | null {
  let popup: Window | null = null;
  try {
    popup = window.open('', name, POPUP_FEATURES);
  } catch {
    return null;
  }
  if (!popup) return null;
  try {
    popup.document.title = 'Gencoin secure payment';
    if (popup.document.body) popup.document.body.textContent = 'Opening secure payment page…';
  } catch {
    /* a reused named window may already be cross-origin */
  }
  return popup;
}

/** Points the blank popup at the provider; false when there is no usable window. */
export function sendPopupTo(popup: Window | null, url: string): boolean {
  if (!popup) return false;
  try {
    if (popup.closed) return false;
    popup.location.replace(url);
    return true;
  } catch {
    return false;
  }
}

/** Best effort only: provider COOP can make this a no-op. */
export function closePopup(popup: Window | null): void {
  try {
    popup?.close();
  } catch {
    /* nothing to do */
  }
}
